<template>
  <div class="p-2">
    <div class="form-group col-md-5">
      <DatePicker
        v-model="date_start"
        valueType="YYYY-MM-DD"
        title-format="DD.MM.YYYY"
        placeholder="начало периода"
        class="m-2"
      ></DatePicker>
      <DatePicker
        v-model="date_end"
        valueType="YYYY-MM-DD"
        title-format="DD.MM.YYYY"
        placeholder="конец периода"
        class="m-2"
      ></DatePicker>
      <button class="btn btn-sm btn-primary m-2 shadow-none" @click="get_data">
        сформировать
      </button>
      <button class="btn btn-sm btn-primary m-2 shadow-none" @click="get_data_spis">
        отчет по списаниям
      </button>
    </div>
    <div v-if="save_files" class="ml-4">
      <div v-for="(item, idx) in save_files" :key="idx">
        <a
          :href="`${url}admin/repairs_report_period/file/${item}`"
          target="_blank"
          >{{ item }}</a
        >
        <a href="" class="ml-2" @click.prevent="del_file(item)">удалить</a>
      </div>
    </div>
    <a v-if="file" :href="`${file}`" target="blank" ref="upl" class="d-none">скачать</a>
    <Loader v-if="loading" />
  </div>
</template>
<script>
import Loader from "@/components/Loader";
import u from "@/constants/";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";
import { HTTPGET } from "@/api";
export default {
  name: "RepairsReportPeriod",
  components: {
    DatePicker,
    Loader
  },
  mounted() {
    this.listSaveFiles();
  },
  data: () => ({
    date_start: null,
    date_end: null,
    file: null,
    save_files: null,
    url: u.url1,
    loading: false
  }),
  methods: {
    get_data() {
      if (this.date_end && this.date_start) {
      this.loading = true;
        HTTPGET({
          url: "admin/repairs_report_period/get_data.php",
          params: { date_start: this.date_start, date_end: this.date_end }
        }).then(response => {
          this.file =
            u.url1 + "admin/repairs_report_period/file/" + response.data.file;
        }).then(() => this.$refs.upl.click())
        .then(() => {
        this.listSaveFiles();
      })
        .then(() => (this.loading = false));
      }
    },
    get_data_spis() {
      if (this.date_end && this.date_start) {
      this.loading = true;
        HTTPGET({
          url: "admin/repairs_report_period/get_data_spis.php",
          params: { date_start: this.date_start, date_end: this.date_end },
    responseType: 'blob',
    withCredentials: true
        })
.then(response => {
    const disposition = response.headers['content-disposition'];
    let fileName = 'spisanie.xls';
    if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match) fileName = match[1];
    }
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
})
.catch(error => console.error('Ошибка скачивания:', error)).then(() => (this.loading = false));
      }
    },
    listSaveFiles() {
      HTTPGET({
        url: "admin/repairs_report_period/list_save_files.php"
      }).then(response => {
        this.save_files = response.data.files;
      });
    },
    del_file(name) {
      HTTPGET({
        url: "admin/repairs_report_period/del_file.php",
        params: {
          name
        }
      }).then(() => {
        this.listSaveFiles();
      });
    }
  }
};
</script>
<style scoped>
.none {
display: none;
}